import ReactDOM from 'react-dom/client';
import './index.css';
// import './fonts/tablericons.css'
import './iconfonts.css'
import App from './App';

import { Provider } from 'react-redux'

import store from './store';

// Chromium reports this when ResizeObserver runs in the same frame as a layout-affecting
// update (charts, portals, route changes). It is not actionable. webpack-dev-server still
// treats it as a crash overlay, so suppress the event and remove the overlay if it appears.
const RESIZE_OBSERVER_LOOP_RE = /ResizeObserver loop/i

function resizeObserverEventMessage(event) {
    return event?.message || event?.reason?.message || event?.reason || event?.error?.message || ''
}

function dismissWebpackRuntimeOverlay() {
    const overlay = document.getElementById('webpack-dev-server-client-overlay')
    if (overlay) overlay.remove()
}

function suppressResizeObserverLoop(event) {
    if (!RESIZE_OBSERVER_LOOP_RE.test(String(resizeObserverEventMessage(event)))) {
        return
    }
    event.preventDefault?.()
    event.stopImmediatePropagation?.()
    dismissWebpackRuntimeOverlay()
    requestAnimationFrame(dismissWebpackRuntimeOverlay)
    setTimeout(dismissWebpackRuntimeOverlay, 0)
}

window.addEventListener('error', suppressResizeObserverLoop, true)
window.addEventListener('unhandledrejection', suppressResizeObserverLoop, true)

if (typeof MutationObserver !== 'undefined') {
    const overlayObserver = new MutationObserver(() => {
        const overlay = document.getElementById('webpack-dev-server-client-overlay')
        if (!overlay) return
        const inspect = () => {
            try {
                const text = overlay.contentDocument?.body?.innerText || ''
                if (RESIZE_OBSERVER_LOOP_RE.test(text)) {
                    overlay.remove()
                }
            } catch {
                // iframe may not be readable until load
            }
        }
        inspect()
        overlay.addEventListener('load', inspect, { once: true })
    })
    overlayObserver.observe(document.documentElement, { childList: true, subtree: true })
}

const root = ReactDOM.createRoot(document.getElementById('root'));
root.render(
    <Provider store={store}>        
        <App />
    </Provider> 
);

